import {default as acFormatMoney} from "accounting-js/lib/formatMoney.js";

export function formatMoney(value, options = {precision: 2}) {
  if (Number(value)){
    return acFormatMoney(value, options)
  }
  else
    return '-'
}
